import { Role } from '@/utils/definitions';

export function isAdmin(role: Role): boolean {
  return [Role.Admin, Role.Root, Role.SYSTEM].includes(role);
}
